import { Component, Input, OnInit, OnDestroy, Inject, Optional, HostListener } from '@angular/core';
import { DisclosureContentService } from '../../services/disclosure-content.service';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'faqs-content',
    templateUrl: './faqs-content.component.html'
})

export class FaqsContentComponent implements OnInit, OnDestroy {
    articleId: string;
    communityName: string;
    @Input() isHeaderRequired: boolean = false;
    isAda: boolean = false;
    constructor(private disclosureContentService: DisclosureContentService, @Optional() @Inject('AppSettings') appSettings: any,
                private translationService: PershingTranslationService ) {
        if (appSettings.themeType === 'ada') {
            this.isAda = true;
        }
        this.translationService.addTranslationFolder('@pershing/nxi-contentmanagement', 'node_modules/@pershing/nxi-contentmanagement/lib');
    }

    ngOnInit(): void {
        this.articleId = this.disclosureContentService.getArticleIdForCurrentPage();
        this.communityName = this.disclosureContentService.getCommunityName();
        console.log('communityname from disclosure service' + this.communityName);
        console.log('articleId from disclosure service' + this.articleId);
    }

    ngOnDestroy(): void {

    }

    @HostListener('click', ['$event'])
    handleClick(event: Event): void {
        let target = event.target as HTMLElement;
        if (target && target.classList && target.classList.contains('quest')) {
            event.preventDefault();
            let child = document.getElementById('ans' + target.id) as HTMLElement;
            if (child) {
                child.style.display = (child.style.display === 'block') ? 'none' : 'block';
            }
        }
    }

    faqOnChange(obj: any) {
        let listOfDivs = ['div0', 'div1', 'div2', 'div3', 'div4', 'div5'];
        listOfDivs.forEach((element, index) => {
            if (!document.getElementById('div' + (index))) {
                return;
            }
            if (obj !== index.toString()) {
                document.getElementById('div' + (index)).style.display = 'none';
            } else {
                document.getElementById('div' + (index)).style.display = 'block';
            }
        });
    }
}
